import { Input, Popover } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { SketchPicker } from "react-color";

const ColorPicker = ({ value, onChange }) => {
  const containerRef = useRef(null);
  const [popoverContainer, setPopoverContainer] = useState(document.body);
  const [color, setColor] = useState("#000000");

  useEffect(() => {
    console.log(value);
    setColor(value || "#000000");
  }, [value]);

  const handleChangeColor = (c) => {
    const { hex } = c;
    setColor(hex);
    onChange(hex);
  };

  useEffect(() => {
    if (containerRef.current) {
      setPopoverContainer(containerRef.current);
    }
  }, [containerRef]);

  return (
    <>
      <Input className="hidden" placeholder="Color" />

      <div className="flex items-center space-x-3">
        <div
          className="w-8 h-8 rounded relative border border-gray-300 p-1 cursor-pointer"
          ref={containerRef}
        >
          <Popover
            getPopupContainer={() => popoverContainer}
            trigger={["click"]}
            placement="leftTop"
            overlayClassName="inner-padding-none"
            content={() => (
              <SketchPicker
                disableAlpha={false}
                className="z-20"
                presetColors={[
                  "#D0021B",
                  "#F5A623",
                  "#F8E71C",
                  "#8B572A",
                  "#7ED321",
                  "#417505",
                  "#BD10E0",
                  "#9013FE",
                ]}
                color={color}
                onChangeComplete={handleChangeColor}
              />
            )}
          >
            <div
              className="w-full h-full rounded"
              style={{ backgroundColor: color }}
            />
          </Popover>
        </div>
        <span>{color}</span>
      </div>
    </>
  );
};

export default ColorPicker;
